import { ColorPicker } from '@/components';
import { Select } from 'antd';
import { useContext, useState, type FC } from 'react';
import { DashboardSearchContext } from '..';

import type { SelectProps } from 'antd';
import { Tag } from 'antd';

type TagRender = SelectProps['tagRender'];

export type MultiSelectOption = {
  value: string;
  label: string;
  color: string;
};

const BrandsColorEditor: FC = () => {
  const {
    colorMap,
    setColorMap,
    activeBrands,
    setActiveBrands,
    isLoading,
    isMyBrands,
  } = useContext(DashboardSearchContext);

  const updateColor = (brand: string, newColor: string) => {
    colorMap.set(brand, newColor);
    setColorMap?.(new Map(colorMap));
  };

  const [isOpen, setIsOpen] = useState(false);

  const chooseAllBrands = 'Выбрать все';

  const onChangeActive = (newArrOfBrands: string[]) => {
    if (
      newArrOfBrands &&
      newArrOfBrands.length &&
      newArrOfBrands.includes(chooseAllBrands)
    ) {
      if (newArrOfBrands.length === [...colorMap.keys()].length + 1) {
        return [];
      }
      return setActiveBrands?.([...colorMap.keys()]);
    }
    return setActiveBrands?.(newArrOfBrands);
  };

  // const multiSelectOptions: MultiSelectOption[] = [
  //   {
  //     label: chooseAllBrands,
  //     value: chooseAllBrands,
  //   },
  //   {
  //     label: 'Бренды',
  //     options: [...colorMap.keys()].map((brand) => ({
  //       label: brand,
  //       value: brand,
  //       color: colorMap.get(brand),
  //     })),
  //   },
  // ];

  const multiSelectOptions = [
    {
      value: chooseAllBrands,
      label: chooseAllBrands,
    },
    {
      value: 'Бренды',
      label: 'Бренды',
      options: [...colorMap.keys()].map((brand) => ({
        value: brand,
        color: colorMap.get(brand),
      })),
    },
  ];

  if (isMyBrands) return null;

  const tagRender: TagRender = ({ value, closable, onClose }) => {
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        closable={closable}
        onClose={onClose}
        onMouseDown={onPreventMouseDown}
        style={{
          marginRight: 3,
          display: 'flex',
          backgroundColor: 'rgba(0, 0, 0, 0.06)',
          border: '1px solid transparent',
        }}
      >
        <button
          onClick={(e) => e.stopPropagation()}
          className="flex cursor-default items-center gap-1"
        >
          <ColorPicker
            width={16}
            color={colorMap.get(value) as string}
            action={(newColor: string) => updateColor(value, newColor)}
          />
          {value}
        </button>
      </Tag>
    );
  };

  return (
    <div className="flex max-w-full flex-wrap items-center justify-end gap-2">
      <Select
        mode="multiple"
        loading={isLoading}
        disabled={isLoading}
        open={isOpen}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        allowClear
        className="w-full max-w-sm shrink-0 grow overflow-auto"
        style={{ width: '100%' }}
        popupClassName="overflow-auto"
        placeholder="Please select"
        maxTagCount="responsive"
        value={activeBrands}
        options={multiSelectOptions}
        tagRender={tagRender}
        onChange={onChangeActive}
        optionRender={({ value }: MultiSelectOption) => (
          <div className="flex items-center gap-1">
            <button onClick={(e) => e.stopPropagation()}>
              <ColorPicker
                color={colorMap.get(value) as string}
                action={(newColor: string) => updateColor(value, newColor)}
              />
            </button>
            {value}
          </div>
        )}
      />

      {/* <div className="shrink-0">
        <Dropdown
          disabled={colorMap.size === 0 || isLoading}
          label="Цвета брендов"
          dismissOnClick={false}
        >
          <div className="max-h-[200px]  overflow-scroll">
            {activeBrands.map((brand) => (
              <Dropdown.Item key={brand}>
                <div className="flex w-full items-center justify-between">
                  {brand}
                  <ColorPicker
                    color={colorMap.get(brand) as string}
                    action={(newColor: string) => updateColor(brand, newColor)}
                  />
                </div>
              </Dropdown.Item>
            ))}
          </div>
        </Dropdown>
      </div> */}
    </div>
  );
};

export default BrandsColorEditor;
